<template>
  <div class="uvStatistics">
    <div class="management-search">
      <div class="management-search-1">
        模板：
        <a-select
          v-model="modelId"
          placeholder="请选择模板"
          class="select-tag"
          @change="query"
        >
          <a-select-option
            v-for="(item, index) in modelList"
            :key="item.id"
            :value="item.id"
          >
            <span :style="{ color: item.enabled ? 'green' : 'grey' }">{{
              item.name
            }}</span>
          </a-select-option>
        </a-select>
      </div>
      <div class="management-search-1">
        手机号：
        <a-input
          placeholder="请输入手机号"
          v-model="phone"
          @keyup.enter="query(1)"
          allow-clear
        ></a-input>
      </div>
      <div class="management-search-1">
        时间：
        <a-date-picker
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          v-model="startTime"
          placeholder="开始时间"
        />
        <i style="display: inline-block; margin-left: 20px"></i>
        <a-date-picker
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="结束时间"
          v-model="endTime"
        />
      </div>
    </div>
    <div class="projectList-search-button">
      <a-button type="primary" @click="query(1)">查询</a-button>
      <i style="display: inline-block; margin-right: 20px"></i>
      <a-button type="primary" @click="ExportData">导出</a-button>
      <i style="display: inline-block; margin-right: 20px"></i>
      <a-button type="link" @click="searchParam">自定义过滤</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="tablePagination"
      :loading="loadingTable"
      size="middle"
      :rowKey="(record) => record.手机号"
    >
      <span slot="registerRate" slot-scope="text, record"> {{ text }}% </span>
    </a-table>

    <a-modal
      title="自定义过滤"
      v-model="visible"
      :maskClosable="false"
      class="action-class"
      width="500px"
    >
      <a-form>
        <template v-for="item in searchParamList">
          <a-form-item
            :label="item.field"
            :key="item.id"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 15 }"
            v-if="item.optionList"
          >
            <a-select
              v-model="item.value"
              :placeholder="`请选择${item.field}`"
              class="select-tag"
              allowClear
            >
              <a-select-option
                v-for="(option, index) in item.optionList"
                :key="index"
                :value="option"
                >{{ option }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item
            :label="item.field"
            :key="item.id"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 15 }"
            v-else
          >
            <a-input
              v-model="item.value"
              :placeholder="`请输入${item.field}`"
            />
          </a-form-item>
        </template>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="visible = false">取消</a-button>
          <a-button key="submit" type="primary" @click="submit">确定</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
import api from "../lib/formDataList.js";
import formMaintenanceApi from "../lib/formMaintenance.js";
import moment from "moment";

export default {
  name: "uvStatistics",
  data() {
    return {
      phone: "",
      tableColumns: [],
      tableDataSource: [],
      loadingTable: false,
      startTime: null,
      endTime: null,
      pageNo: 1,
      tablePagination: {},
      searchParamList: [],
      paramList: [],
      visible: false,
      modelList: [],
      modelId: undefined,
    };
  },
  computed: {
    lastLoginDateEndTime() {
      // 开始时间
      if (this.endTime) {
        return this.$common.transformTime(this.endTime);
      }
      return "";
    },
    lastLoginDateStartTime() {
      // 结束时间
      if (this.startTime) {
        return this.$common.transformTime(this.startTime);
      }
      return "";
    },
  },
  mounted() {
    this.today();
    this.getModelList();
  },
  methods: {
    getModelList() {
      formMaintenanceApi.list().then((res) => {
        if (res.result == 200) {
          this.modelList = res.data;
          for (let index = 0; index < this.modelList.length; index++) {
            if (this.modelList[index].enabled) {
              this.modelId = this.modelList[index].id;
              break;
            }
          }
          this.getSearchParamList();
        }
      });
    },
    getSearchParamList() {
      api.systemFormDataSearchParam({ modelId: this.modelId }).then((res) => {
        if (res.result == 200) {
          this.searchParamList = res.data;
          this.searchParamList.forEach((item, index) => {
            this.$set(item, "value", undefined);
            this.$set(item, "id", index + 1);
          });
          this.query(1);
        }
      });
    },
    submit() {
      this.paramList.splice(0);
      this.searchParamList.forEach((item) => {
        if (item.value) {
          this.paramList.push({ field: item.field, value: item.value });
        }
      });
      this.visible = false;
      this.query();
    },
    searchParam() {
      this.visible = true;
    },
    ExportData() {
      location.href =
        process.env.VUE_APP_CURRENTMODE == "dev"
          ? process.env.VUE_APP_BASE_API
          : location.origin +
            `/api/manager/formData/exportSystemFormDataPage?phone=${
              this.phone
            }&startTime=${this.lastLoginDateStartTime}&endTime=${
              this.lastLoginDateEndTime
            }&param=${encodeURIComponent(
              JSON.stringify(this.paramList)
            )}&modelId=${this.modelId}`;
    },
    today() {
      let startTime = new Date();
      startTime.setHours(0);
      startTime.setMinutes(0);
      startTime.setSeconds(0);
      startTime.setMilliseconds(0);
      let endTime = new Date();
      endTime.setHours(23);
      endTime.setMinutes(59);
      endTime.setSeconds(59);
      endTime.setMilliseconds(59);
      this.startTime = moment(startTime, "YYYY-MM-DD HH:mm:ss");
      this.endTime = moment(endTime, "YYYY-MM-DD HH:mm:ss");
    },
    // 点击查询
    query(index) {
      if (index) {
        this.pageNo = index;
      }
      let data = {
        phone: this.phone,
        startTime: this.lastLoginDateStartTime,
        endTime: this.lastLoginDateEndTime,
        pageSize: 10,
        pageNo: this.pageNo,
        param: encodeURIComponent(JSON.stringify(this.paramList)),
        modelId: this.modelId,
      };
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .systemFormDataPage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            this.tableDataSource = res.data.records;
            this.tableColumns.splice(0);
            if (this.tableDataSource.length > 0) {
              for (const key in this.tableDataSource[0]) {
                this.tableColumns.push({
                  title: key,
                  dataIndex: key,
                });
              }
            }
            this.tablePagination = {
              showQuickJumper: true,
              showTotal: () => `共${res.data.total}条`,
              pageSize: data.pageSize,
              current: data.pageNo,
              total: res.data.total,
              onChange: (current) => this.changePageItem(current),
            };
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
    changePageItem(index) {
      this.query(index);
    },
  },
};
</script>
<style lang="scss" scoped>
.uvStatistics {
  .management-search {
    position: relative;
    overflow: hidden;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .backup {
      padding: 5px 0;
    }
    span {
      width: 240px;
    }
    input {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
  .projectList-search-button {
    margin-bottom: 20px;
    button {
      margin-right: 20px;
    }
    .request_nav_item {
      display: inline-block;
      margin-right: 20px;
      width: 350px;
      input {
        width: 250px;
      }
      .ant-select {
        width: 250px;
      }
    }
  }
}
</style>
